export default __webpack_public_path__ + "static/ryan@2x-a41c48ce74d1cfcf028397dca1314336.jpg";